export { default as CompleteInfoView } from 'auth/components/CompleteInfoView';
export { default as UpdateInfoView } from 'auth/components/UpdateInfoView';
export { default as Layout } from 'auth/components/AuthLayout';
export { default as LoginView } from 'auth/components/LoginView';
export { default as RecoverPasswordView } from 'auth/components/RecoverPasswordView';
export { default as ResetPasswordView } from 'auth/components/ResetPasswordView';



// WEBPACK FOOTER //
// src/modules/auth/components/index.js